import { Suspense, lazy, useEffect, useState } from "react";
import {
  DeleteButton,
  PlusButton,
  ActionButton,
  ToggleSwitch,
} from "../../helper/ImageFormat";
import Breadcrumb from "../../helper/Breadcrumb";
import Spinner from "../../Components/spinner";
import {
  toggleStatus,
  deleteItem,
  submitForm,
  deleteMultipleItem,
} from "../../utils/apiUtils";
import { fetchAllData } from "../../helper/ProductAttributeHandling";
import { confirmBulkDelete } from "../../Components/DeleteModel";
import { ImportExcellModal } from "../../Model/Model";
import dateformate from "../../helper/DateFormate";
const DeleteModal = lazy(() => import("../../Components/DeleteModel"));
const SizeModal = lazy(() =>
  import("../../Model/Model").then((mod) => ({ default: mod.SizeModal }))
);

const Size = () => {
  const [loading, setLoading] = useState(false);
  const [sizeData, setSizeData] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [formData, setFormData] = useState({ value: "", isActive: true });
  const [errors, setErrors] = useState({});
  const [btnLoading, setBtnLoading] = useState(false);
  const [deleteItemId, setDeleteItemId] = useState({});
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [selected, setSelected] = useState([]);
  const [ExcellModel, setExcellModel] = useState(false);
  const [nextPosition, setNextPosition] = useState(0);
  const fetchData = async () => {
    await fetchAllData("size-pagination", setSizeData, null, setLoading,setNextPosition);
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    const target = sizeData.find((item) => item.id === editingId);
    setFormData(target ? { value: target.value,isActive:target.isActive } : { value: "",isActive:true });
  }, [editingId, sizeData]);

  const toggleModal = () => {
    setModalOpen(!modalOpen);
    setEditingId(null);
    setFormData({ value: "", isActive: true });
    setErrors({});
  };

  const handleChange = (eOrName, value) => {
    if (typeof eOrName === "string") {
      setFormData((prev) => ({ ...prev, [eOrName]: value }));
      setErrors((prev) => ({ ...prev, [eOrName]: "" }));
    } else {
      const { name, value } = eOrName.target;
      if (Number(value) < 0) {
        setErrors((prev) => ({
          ...prev,
          [name]: "Negative values are not allowed",
        }));
        return;
      }
      setFormData((prev) => ({ ...prev, [name]: value }));
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({});
     if (!formData.value) {
  setErrors({ value: "Value is required" })
    setBtnLoading(false);
    return;
  }
    setBtnLoading(true);
    try {
      await submitForm({
        data: formData,
        url: "/size",
        editingId,
        validateFields: [],
        validationErrorsSetter: setErrors,
        onSuccess: fetchData,
        closeModal: () => setModalOpen(false),
      });
    } finally {
      setBtnLoading(false);
    }
  };

  const confirmDelete = async () => {
    setIsDeleting(true);
    try {
      const res = await deleteItem("size", deleteItemId?.id, fetchData);
      setDeleteItemId({});
      setDeleteModalOpen(false);
      return res;
    } catch (error) {
      return error;
    } finally {
      setIsDeleting(false);
    }
  };

  const handleStatusToggle = async (item) => {
    const updated = await toggleStatus("size-status", item.id, item.isActive);
    if (updated) {
      setSizeData((prev) =>
        prev.map((s) =>
          s.id === item.id ? { ...s, isActive: updated.isActive } : s
        )
      );
    }
  };

  const handleBulkDelete = async () => {
    await confirmBulkDelete({
      itemType: "Sizes",
      selectedIds: selected,
      deleteApiCall: (ids) => deleteMultipleItem("sizes-bulk-delete", ids),
      refreshCallback: fetchData,
    });
  };

  const isAllSelected =sizeData.length > 0 && selected.length === sizeData.length;

  const toggleSelectAll = () =>
    setSelected(isAllSelected ? [] : sizeData.map((i) => i.id));
  const toggleSelectOne = (id) =>
    setSelected((prev) =>
      prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
    );

  const breadcrumbData = [
    { label: "Home", path: "/" },
    { label: "Sizes", path: "*" },
  ];

  const handleImport = () => {
    setExcellModel((prev) => !prev);
  };
  return (
    <div className="content-wrapper">
      <div className="page-header mt-5">
        <h3 className="custom-page-title">Sizes</h3>
        <Breadcrumb items={breadcrumbData} />
      </div>
      <div
        className="d-flex justify-content-end bg-white p-2 mt-n2"
        style={{ gap: "10px" }}
      >
        <PlusButton handleAdd={toggleModal} module={"Sizes"} />

        {selected.length > 0 && (
          <DeleteButton
            handleAdd={handleBulkDelete}
            name="selected sizes"
            module={"Sizes"}
          />
        )}
      </div>

      <div className="row mt-2">
        <div className="col-md-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
                    <div className="table-responsive" >
                      <table className="custom-table table table-striped">
                        <thead>
                          <tr style={{ marginTop: "10px", border: "2px solid #fff" }}>
                            <th>
                              <input
                                type="checkbox"
                                checked={isAllSelected}
                                ref={(el) => {
                                  if (el)
                                    el.indeterminate = selected.length > 0 && !isAllSelected;
                                }}
                                onChange={toggleSelectAll}
                              />
                            </th>
                            <th>Sizes</th>
                            <th>Updated At</th>
                            <th>Is Active</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {loading ? (
                            <tr>
                              <td colSpan="12" className="text-center">
                                <Spinner />
                              </td>
                            </tr>
                          ) : sizeData.length > 0 ? (
                            sizeData.map((item, index) => (
                                  <tr key={index}>
                                    <td>
                                      <input
                                        type="checkbox"
                                        checked={selected.includes(item.id)}
                                        onChange={() => toggleSelectOne(item.id)}
                                      />
                                    </td>
                                    <td>{item.value}</td>
                                    <td>{dateformate(item.updatedAt)}</td>
                                    {/* <td>{dateformate(item.createdAt)}</td> */}
                                    <td>
                                      <Suspense fallback={<span>...</span>}>
                                        <ToggleSwitch
                                          data={item}
                                          name="isActive"
                                          checked={item.isActive}
                                          handleStatusToggle={handleStatusToggle}
                                          module={"Sizes"}
                                        />
                                      </Suspense>
                                    </td>
                                    <td>
                                      <Suspense fallback={<span>...</span>}>
                                        <ActionButton
                                          data={item}
                                          module={"Sizes"}
                                          handleEditClick={() => {
                                            setEditingId(item.id);
                                            setModalOpen(true);
                                          }}
                                          handleDelete={() => {
                                            setDeleteItemId(item);
                                            setDeleteModalOpen(true);
                                          }}
                                        />
                                      </Suspense>
                                    </td>
                                  </tr>                           
                            ))
                          ) : (
                            <tr>
                              <td colSpan="5" className="text-center">
                                <h5>No data found.</h5>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
               
            </div>
          </div>
        </div>
      </div>

      <Suspense fallback={null}>
        {modalOpen && (
          <SizeModal
            isOpen={modalOpen}
            toggle={toggleModal}
            editingId={editingId}
            data={formData}
            errors={errors}
            loading={btnLoading}
            handleChange={handleChange}
            handleSubmit={handleSubmit}
            nextPosition={nextPosition}
          />
        )}
      </Suspense>

      <Suspense>
        {ExcellModel && (
          <ImportExcellModal
            modalOpen={ExcellModel}
            toggleModal={handleImport}
            fetchdata={fetchData}
            apiUrl={"/size-import"}
            Heading={"Upload size  CSV file"}
          />
        )}
      </Suspense>
      <Suspense fallback={null}>
        {deleteModalOpen && (
          <DeleteModal
            deleteModalOpen={deleteModalOpen}
            setDeleteModalOpen={() => setDeleteModalOpen(false)}
            onConfirm={confirmDelete}
            itemName="size"
            isDeleting={isDeleting}
          />
        )}
      </Suspense>
    </div>
  );
};

export default Size;
